import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchClerkingCustomers, putClerkingCustomerById } from '../fetch/customers';
import isNil from 'lodash/isNil';
import { JSON_PARSE_ERROR } from './consts';

export const getClerkingCustomers = createAsyncThunk(
  'customers/getClerkingCustomersStatus',
  (_, { rejectWithValue }) => fetchClerkingCustomers()
      .then(({ data }) => ({ clerkingCustomers: data }))
      .catch((err) => rejectWithValue({ error: err })),
  {
    condition: (_, { getState }) => {
      const { customers } = getState();
      if (isNil(customers) || customers.isLoadingClerkingCustomers) {
        return false;
      }
    },
  },
);

export const putClerkingCustomer = createAsyncThunk(
  'customers/putClerkingCustomerStatus',
  ({ customerId, addRemove }, { rejectWithValue }) => putClerkingCustomerById(customerId, addRemove)
      .catch((err) => rejectWithValue({ error: err })),
  {
    condition: (_, { getState }) => {
      const { customers } = getState();
      if (isNil(customers) || customers.isUpdatingClerkingCustomer) {
        return false;
      }
    },
  },
);

const initialState = {
  isLoadingClerkingCustomers: false,
  clerkingCustomers: [],
  isUpdatingClerkingCustomer: false,
  error: null,
};

const customersSlice = createSlice({
  name: 'customers',
  initialState,
  extraReducers: {
    [getClerkingCustomers.pending]: (state) => {
      state.error = null;
      state.isLoadingClerkingCustomers = true;
    },
    [getClerkingCustomers.fulfilled]: (state, { payload: { clerkingCustomers } }) => {
      state.isLoadingClerkingCustomers = false;
      state.clerkingCustomers = clerkingCustomers;
    },
    [getClerkingCustomers.rejected]: (state, { payload: { error } }) => {
      state.isLoadingClerkingCustomers = false;
      state.error = error.message === JSON_PARSE_ERROR ? 'Error retrieving clerking customer list!' : error.message;
    },
    [putClerkingCustomer.pending]: (state) => {
      state.error = null;
      state.isUpdatingClerkingCustomer = true;
    },
    [putClerkingCustomer.fulfilled]: (state) => {
      state.isUpdatingClerkingCustomer = false;
    },
    [putClerkingCustomer.rejected]: (state, { payload: { error } }) => {
      state.isUpdatingClerkingCustomer = false;
      state.error = error.message === JSON_PARSE_ERROR ? 'Error updating clerking customer list!' : error.message;
    },
  },
});

export default customersSlice.reducer;
